"use strict";

var isStringBlank = require(161);

function isSANB(val) {
  return typeof val === 'string' && !isStringBlank(val);
}

module.exports = isSANB;